<div class="modify-password-container">
    <h4 style="text-align: center;">Cambiar Contraseña</h4>
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
        <!-- Contraseña Actual -->
        <mat-form-field appearance="fill">
            <mat-label>Contraseña Actual</mat-label>
            <input matInput [type]="hideCurrentPassword ? 'password' : 'text'" formControlName="currentPassword"
                required />
            <button type="button" mat-icon-button matSuffix (click)="toggleCurrentPassword()"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideCurrentPassword ">
                <mat-icon class="icon-toggle">{{ hideCurrentPassword ? 'visibility_off' : 'visibility'
                    }}</mat-icon>
            </button>
            <mat-error *ngIf="passwordForm.get('currentPassword')?.invalid">
                Este campo es requerido.
            </mat-error>
        </mat-form-field>

        <!-- Nueva Contraseña -->
        <mat-form-field appearance="fill">
            <mat-label>Nueva Contraseña</mat-label>
            <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword" required />
            <button type="button" mat-icon-button matSuffix (click)="toggleNewPassword()"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword  ">
                <mat-icon class="icon-toggle">{{ hideNewPassword ? 'visibility_off' : 'visibility'
                    }}</mat-icon>
            </button>
            <mat-error
                *ngIf="passwordForm?.get('newPassword')?.invalid && (passwordForm?.get('newPassword')?.touched || passwordForm?.get('newPassword')?.dirty)"
                style="width: 105%; margin-left: -10px; padding: 0;">
                {{ getNewPasswordErrorMessage() }}
            </mat-error>
        </mat-form-field>


        <!-- Confirmar Nueva Contraseña -->
        <mat-form-field appearance="fill">
            <mat-label>Confirmar Nueva Contraseña</mat-label>
            <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword"
                required />
            <button type="button" mat-icon-button matSuffix (click)="toggleConfirmPassword()"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword  ">
                <mat-icon class="icon-toggle">{{ hideConfirmPassword ? 'visibility_off' : 'visibility'
                    }}</mat-icon>
            </button>
            <mat-error *ngIf="passwordForm.get('confirmPassword')?.invalid">
                Este campo es requerido.
            </mat-error>
        </mat-form-field>

        <!-- Mensaje de notificación -->
        <div class="notification-container" *ngIf="notification.message">
            <div class="notification" [ngClass]="notification.type">
                {{ notification.message }}
            </div>
        </div>

        <!-- Botones -->
        <div class="button-group">
            <button mat-raised-button color="primary" type="submit" [disabled]="passwordForm.invalid">
                Guardar Cambios
            </button>
            <button mat-raised-button color="warn" mat-dialog-close class="send" *ngIf="data === true">Cancelar</button>
        </div>
    </form>
</div>